import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';
import { fetchNewProjects, getNewProjects } from 'project/ducks/project';
import { getProjectIdFromUrl } from 'project/utils';
import NewProjects from 'project/components/new_projects';

const mapStateToProps = (state) => {
  return {
    projects: getNewProjects(state),
    categories: state.categories.data
  };
}

const mapDispatchToProps = (dispatch, { params }) => {
  const projectId = getProjectIdFromUrl(params);
  return bindActionCreators({
    fetch: partial(fetchNewProjects, projectId),
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewProjects));



// WEBPACK FOOTER //
// ./project/containers/new_projects.js